import { useLazyQuery } from "@apollo/client/react";
import { useMemo, useEffect, useState } from 'react';
import DataGridGenerico from '../../../components/dataGrid/DataGridGenerico';
import { generateColumnsDefaultConfiguration } from '../../../components/dataGrid/columnHelpers';
import { Button, Grid } from '@mui/material';
import { TextInput } from '../../../components/textInput/TextInput';
import { useDebounce } from '../../../hooks/useDebounce';
import './gestionLogisticaContent.scss';
import { adaptSolicitudGestLogisticaArray } from '../../../adapters/solicitudesGestLogisticaAdapter';
import { GET_SOLICITUDES_GESTION_LOGISTICA } from '../../../data/graphQL/queries/GestionLogistica/getSolicitudesGestionLogistica';
import { useNavigate } from 'react-router-dom';
import FilterAltIcon from '@mui/icons-material/FilterAlt';
import { GET_DELEGACIONES_BY_USUARIO } from '../../../data/graphQL/queries/PacienteProbable/getAllDelegacionesByUsuario';
import { adaptDelegacionArray } from '../../../adapters/delegacionAdapter';
import { SelectInput } from '../../../components/selectInput/SelectInput';
import { GET_ESTADOS_LOGISTICA } from '../../../data/graphQL/queries/GestionLogistica/getGestionLogisticaEstado';
import 'moment/locale/es';
import Chip from '@mui/material/Chip';
import moment from 'moment';
import EditIcon from '@mui/icons-material/Edit';
import toast from 'react-hot-toast';
import { usePersistFilters } from '../../../hooks/usePersistFilters';
import { DateInput } from '../../../components/dateInput/DateInput';
import { CustomDialog } from '../../../components/customDialog/CustomDialog';
import { CustomChip } from '../../../components/chip/Chip';
import { CustomButton } from '../../../components/customButton/CustomButton';
import { downloadExcel } from '../../../utils/downloadExcel';

export const GestionLogisticaContent = ({ setChildrenAction }) => {
  const navigate = useNavigate();
  const [dataExcel, setDataExcel] = useState('');
  const [
  rows,
  selectedActivityFilter,
  setSelectedActivityFilter,
  handleChangePaginationStatus,
  paginationStatus,
  totalCount,
  filterStatus,
  setFilterStatus,
  delegacionSelected,
  estadoFiltro,
  fechaDesde,
  fechaHasta,
  handleChangeFilters,
  filters] =
  useGetGestionLogistica({ setDataExcel });


  const [open, setOpen] = useState(false);
  const [exportLoading, setExportLoading] = useState(false);

  const [estados, setEstados] = useState([]);
  const [delegaciones, setDelegaciones] = useState([]);

  const [delegacionAuxSelected, setDelegacionAuxSelected] = useState(filters?.delegacionSelected);
  const [fechaAuxDesde, setFechaAuxDesde] = useState(filters?.fechaDesde);
  const [fechaAuxHasta, setFechaAuxHasta] = useState(filters?.fechaHasta);
  const [estadoAuxFiltro, setEstadoAuxFiltro] = useState(filters?.estadoFiltro);

  const handleClickMore = (row) => {
    navigate('/gestionLogistica/detalleGestionLogistica',
    {
      state: {
        solicitud: row
      }
    });
  };

  const getChipEstado = (gestionEstado) => {
    const idEstado = gestionEstado?.idGestionLogisticaEstado;
    const labelEstado = gestionEstado?.descripcion;
    switch (idEstado) {
      // Pendiente
      case 1:
        return (
          <CustomChip label={labelEstado} isYellow />);
      // Aprobado
      case 2:
        return (
          <CustomChip label={labelEstado} isGreen />);
      // Rechazado
      case 3:
        return (
          <CustomChip label={labelEstado} isRed />);
      // Pedido de cambio
      case 4:
        return (
          <CustomChip label={labelEstado} isLightBlue isMultiLine />);
      default:
        return (
          <CustomChip label={labelEstado} isLightBlue />);
    }
  };

  const initialColumns = [
  {
    headerName: '',
    field: 'action',
    flex: 0.02,
    renderCell: (cellProps) => {
      const { row } = cellProps;
      return (
        <div className='more-icon' onClick={() => handleClickMore(row)} aria-hidden='true'>
                        <EditIcon className='edit-icon' />
                    </div>);

    }
  },
  {
    flex: 0.15,
    field: 'origen',
    headerName: 'Origen',
    renderCell: ({ row }) => {
      return <Chip className="chip-preview" key={row.ultimaInstancia?.idDistribucionOrigenNavigation?.codigo} label={row.ultimaInstancia?.idDistribucionOrigenNavigation?.codigo} />;
    }
  },
  {
    field: 'idDelegacion',
    headerName: 'Delegación',
    flex: 0.25,
    valueGetter: (idDelegacion) => {
      return delegaciones?.find((tp) => tp.id == idDelegacion)?.displayName;
    }
  },
  {
    field: 'nroContrato',
    headerName: 'Deposito',
    valueGetter: (_, row) => {
      return row.ultimaInstancia?.idProveedorDistribuidorNavigation?.idDepositoNavigation?.descripcion;
    }
  },
  {
    flex: 0.2,
    field: 'tipoContrato',
    headerName: '# Instancia',
    align: 'center',
    valueGetter: (_, row) => {
      return row.ultimaInstancia?.nroInstancia;
    }
  },
  {
    flex: 0.12,
    field: 'idPaciente',
    headerName: 'HC'
  },
  {
    flex: 0.25,
    field: 'codSapPaciente',
    headerName: 'C. de paciente'
  },
  {
    flex: 0.25,
    field: 'paciente',
    headerName: 'Paciente'
  },
  {
    flex: 0.1,
    field: 'codigoPostal',
    headerName: 'CP',
    valueGetter: (_, row) => {
      return row.ultimaInstancia?.idCodigoPostalNavigation?.cP;
    }
  },
  {
    field: 'usuario',
    headerName: 'Alerta Zona',
    type: 'boolean',
    align: 'center'
  },
  {
    flex: 0.2,
    headerName: 'F. Notificación',
    valueGetter: (_, row) => {
      return moment(row.ultimaInstancia?.fechaNotificacion).format('DD/MM/yyyy');
    }
  },
  {
    flex: 0.2,
    field: 'estado',
    headerName: 'Estado',
    headerAlign: 'center',
    renderCell: (cellProps) => {
      const { row } = cellProps;
      return getChipEstado(row.ultimaInstancia?.idGestionLogisticaEstadoNavigation);
    }
  }];


  const columns = useMemo(() => generateColumnsDefaultConfiguration(initialColumns), [delegaciones]);
  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };
  const isValidNumber = (value) => {
    const parsedValue = parseInt(value);
    return typeof parsedValue === 'number' && !isNaN(parsedValue);
  };
  const delegationValue = isValidNumber(delegacionAuxSelected) ? delegacionAuxSelected : filters?.delegacionSelected;
  const estadoValue = isValidNumber(estadoAuxFiltro) ? estadoAuxFiltro : filters?.estadoFiltro;

  const handleAplicar = () => {
    handleChangeFilters('delegacionSelected', delegationValue);
    handleChangeFilters('estadoFiltro', estadoValue);
    handleChangeFilters('fechaDesde', fechaAuxDesde || filters?.fechaDesde);
    handleChangeFilters('fechaHasta', fechaAuxHasta || filters?.fechaHasta);
    setOpen(false);
  };

  const exportExcel = () => {
    setExportLoading(true);
    const columns = [
    "Origen",
    "Delegacion",
    "Deposito",
    "Instancia",
    "HC",
    "CodSapPaciente",
    "Paciente",
    "CP",
    "AlertaZona",
    "FechaNotificacion",
    "Estado"];


    const dataToExport = dataExcel?.map((row) => ({
      Origen: row.ultimaInstancia?.idDistribucionOrigenNavigation?.codigo || '',
      Delegacion: delegaciones?.find((tp) => tp.id == row?.idDelegacion)?.displayName,
      Deposito: row.ultimaInstancia?.idProveedorDistribuidorNavigation?.idDepositoNavigation?.descripcion,
      Instancia: row.ultimaInstancia?.nroInstancia,
      HC: row?.idPaciente || 0,
      CodSapPaciente: row?.codSapPaciente || '',
      Paciente: row?.paciente || '',
      CP: row.ultimaInstancia?.idCodigoPostalNavigation?.cP || '',
      AlertaZona: row?.idProfesionalDerivador || '',
      FechaNotificacion: moment(row.ultimaInstancia?.fechaNotificacion).format('DD/MM/yyyy'),
      Estado: row.ultimaInstancia?.idGestionLogisticaEstadoNavigation?.descripcion
    }));

    downloadExcel({
      fileName: 'SolicitudesGestionLogistica',
      sheet: "GestionLogistica",
      tablePayload: {
        header: columns,
        body: dataToExport
      }
    });

    toast.success("Archivo exportado con éxito");
    setExportLoading(false);
  };

  const storageId = sessionStorage.getItem('idUsuario');
  const [getDelegaciones, { data: delegacionesData, loading: delegacionesLoading }] = useLazyQuery(GET_DELEGACIONES_BY_USUARIO, {
    variables: { idUsuario: JSON.parse(storageId, 10) }
  });

  useEffect(() => {
    if (!delegacionesData) return;
    setDelegaciones(adaptDelegacionArray(delegacionesData));
  }, [delegacionesData]);

  const [getEstados, { data: estadosResult, loading: estadosLoading }] = useLazyQuery(GET_ESTADOS_LOGISTICA);

  useEffect(() => {
    if (!estadosResult) return;
    setEstados(estadosResult.allEstadoLogistica?.map((estado) => {return { id: estado.idGestionLogisticaEstado, displayName: estado.descripcion };}));
  }, [estadosResult]);  

  useEffect(() => {
    if (!estadosLoading) {
      getEstados();
    }
    if (!delegacionesLoading) {
      getDelegaciones();
    }
  }, []);

  useEffect(() => {
    setChildrenAction(() =>
    <>
                <div style={{ display: 'flex' }}>
                    <CustomButton
          style={{ marginRight: 10 }}
          label={'Exportar'}
          loading={exportLoading}
          onClick={() => exportExcel()}
          variant={'outlined'}
          size={'small'}>
          
                        Exportar
                    </CustomButton>
                </div>
            </>
    );
  }, [exportLoading, dataExcel]);

  const handleChangeDelegacionFilter = (value) => {
    setDelegacionAuxSelected(value);
  };

  return (
    <>
            
            <TextInput
        placeholder='Filtrar'
        value={filterStatus}
        width='30%'
        searchIcon
        onChange={(e) => setFilterStatus(e.target.value)}
        onClearButtonClick={() => setFilterStatus('')} />
      
            <Button onClick={() => handleClickOpen()}>
                <FilterAltIcon></FilterAltIcon>
            </Button>
            <div className='grid-container'>
                <DataGridGenerico
          columns={columns}
          rows={rows}
          toolbar={false}
          onPageChange={(page) =>
          handleChangePaginationStatus((prev) => ({
            ...prev,
            page: page
          }))
          }
          onPageSizeChange={(pageSize) =>
          handleChangePaginationStatus((prev) => ({
            ...prev,
            pageSize: pageSize,
            page: 0
          }))
          }
          pageSize={paginationStatus.pageSize}
          totalCount={totalCount}
          currentPage={paginationStatus.page}
          isRowSelectable={(params) => !params.row.ultimaInstancia?.fechaCrediticia} />
        
            </div>

            <CustomDialog
        open={open}
        onClose={handleClose}
        maxWidth='xs'
        fullWidth={true}
        title={'Filtro de búsqueda'}
        onCancel={handleClose}
        onAccept={handleAplicar}
        acceptText='Aplicar'>
        
                <div className='filter-content'>
                    <Grid
            container
            justifyContent={'space-between'}
            spacing={1.5}>
            
                        <Grid size={{ xs: 6 }}>
                            <SelectInput options={[{ id: 0, displayName: 'TODAS' }, ...delegaciones]}
              label='Delegación'
              placeHolder='Elige una delegación'
              value={delegacionAuxSelected}
              onChange={(e) => handleChangeDelegacionFilter(e.target.value)} />
              
                        </Grid>
                        <Grid size={{ xs: 6 }}>
                            <SelectInput options={[{ id: 0, displayName: 'Todos' }, ...estados]}
              label='Estado'
              placeHolder='Elige una delegación'
              value={estadoAuxFiltro}
              onChange={(e) => setEstadoAuxFiltro(e.target.value)} />
              
                        </Grid>
                        <Grid size={{ xs: 6 }}>
                            <DateInput
                label="Desde"
                value={fechaAuxDesde}
                onChange={(e) => setFechaAuxDesde(moment(e).format('yyyy-MM-DD'))} />
              
                        </Grid>
                        <Grid size={{ xs: 6 }}>
                            <DateInput
                label="Hasta"
                value={fechaAuxHasta}
                onChange={(e) => setFechaAuxHasta(moment(e).format('yyyy-MM-DD'))} />
              

                        </Grid>
                    </Grid>
                </div>
            </CustomDialog>
        </>);

};


const useGetGestionLogistica = ({ setDataExcel }) => {
  const [solicitudes, setSolicitudes] = useState([]);
  const [selectedActivityFilter, setSelectedActivityFilter] = useState(0);
  const [paginationStatus, setPaginationStatus] = useState({
    pageSize: 10,
    page: 0
  });

  const { filters, handleChangeFilters } = usePersistFilters(
    {
      estadoFiltro: [1, 4],
      delegacionSelected: 0,
      fechaDesde: null,
      fechaHasta: null
    },
    'gestionLogisticaFilters'
  );

  const {
    estadoFiltro,
    delegacionSelected,
    fechaDesde,
    fechaHasta
  } = filters;


  const [filterStatus, setFilterStatus] = useState('');
  const debouncedFilterValue = useDebounce(filterStatus, 1000);
  const [getSolicitudes, { data: solicitudesData, loading: solicitudesLoading }] = useLazyQuery(GET_SOLICITUDES_GESTION_LOGISTICA, {
    fetchPolicy: 'no-cache'
  });

  useEffect(() => {
    if (!solicitudesData) return;
    setSolicitudes(solicitudesData);
    setDataExcel(adaptSolicitudGestLogisticaArray(solicitudesData));
  }, [solicitudesData]);


  useEffect(() => {
    if (!solicitudesLoading) {
      getSolicitudes({
        variables: {
          skip: paginationStatus.page * paginationStatus.pageSize,
          take: paginationStatus.pageSize,
          where: {
            instanciaLogistica: {
              some: {
                nroInstancia: { gt: 0 }
              }
            },
            or: [
            { idUltimaInstanciaLogisticaNavigation: { idDistribucionOrigenNavigation: { codigo: { contains: debouncedFilterValue } } } },
            { idUltimaInstanciaLogisticaNavigation: { idCodigoPostalNavigation: { cP: { eq: parseInt(debouncedFilterValue) || 0 } } } },
            { t_EvaluacionPaciente: { idPacienteNavigation: { nombre: { contains: debouncedFilterValue } } } },
            { t_EvaluacionPaciente: { idPacienteNavigation: { apellido: { contains: debouncedFilterValue } } } },
            { t_EvaluacionPaciente: { idPacienteNavigation: { idPaciente: { eq: parseInt(debouncedFilterValue) || 0 } } } },
            { t_EvaluacionPaciente: { idPacienteNavigation: { codSAPPaciente: { contains: debouncedFilterValue } } } }],

            and: [
            delegacionSelected ? { idDelegacion: { eq: delegacionSelected } } : {},
            estadoFiltro ? { idUltimaInstanciaLogisticaNavigation: { idGestionLogisticaEstadoNavigation: { idGestionLogisticaEstado: { in: estadoFiltro } } } } : {},
            fechaDesde ? { idUltimaInstanciaLogisticaNavigation: { fechaNotificacion: { gte: fechaDesde } } } : {},
            fechaHasta ? { idUltimaInstanciaLogisticaNavigation: { fechaNotificacion: { lte: fechaHasta } } } : {}]

          },
          order: {
            idEvaluacion: "DESC"
          }
        }
      });
    }
  }, [selectedActivityFilter, paginationStatus, debouncedFilterValue, delegacionSelected, estadoFiltro, fechaDesde, fechaHasta]);
  return [
  adaptSolicitudGestLogisticaArray(solicitudes) || [],
  selectedActivityFilter,
  setSelectedActivityFilter,
  setPaginationStatus,
  paginationStatus,
  solicitudes?.allSolicitudesGestionLogistica?.totalCount,
  filterStatus,
  setFilterStatus,
  delegacionSelected,
  estadoFiltro,
  fechaDesde,
  fechaHasta,
  handleChangeFilters,
  filters];

};